import { Component, OnInit } from '@angular/core';
import { AppConfigService, IAppConfig } from 'src/app/shared/services/app-config.service';

@Component({
  selector: 'app-start-page',
  template: `<ng-container [ngSwitch]="startComponent">
  <app-room-reservation *ngSwitchCase="'room'"></app-room-reservation>
  <app-device-reservation *ngSwitchCase="'device'"></app-device-reservation>

  <div class="container" *ngSwitchDefault>
    <p class="alert alert-danger" role="alert">error in appconfig</p>
  </div>
</ng-container>`
})
export class StartPageComponent implements OnInit {

  startComponent: string;

  constructor() { }

  ngOnInit() {
    const config = AppConfigService.settings;

    if (!config.showRoomReservation && !config.showDeviceReservation) {
      const a = nameof<IAppConfig>('showRoomReservation');
      const b = nameof<IAppConfig>('showDeviceReservation');
      throw Error(`${a} and/or ${b} must be set to 'true' in appconfig.json`);
    }

    this.startComponent = config.showRoomReservation ? 'room' : 'device';
  }

}
